import { useTheme } from "@emotion/react"

const { default: styled } = require("@emotion/styled")
const { Button, Grid, MenuItem, Icon, InputLabel, Select, TextField } = require("@mui/material")
const { Box } = require("@mui/system")
const { useState } = require("react")
const { ValidatorForm } = require("react-material-ui-form-validator")

const H5 = styled('h5')(({ theme }) => ({
    fontSize: '1rem',
    fontWeight: '500',
    marginBottom: '2px',
    textTransform: 'capitalize',
    color: theme.palette.text.primary,
}))
const defaultStage = {
    location: '',
    search: '',
    supervisor: '',
    work:'',
    company:'',
    item_name:''
}
const tests = [
    {name:"ความดันโลหิต", value:"BP"},
    {name:"แอลกอฮอล์", value:"Alcohol"},
    {name:"สารเสพติด", value:"Drug"},
    {name:"ชีพจร", value:"PULSE"},
    {name:"อุณหภูมิ", value:"TEMP"},
]

const SearchFilter = ({locations,
    companies,
    foremen,
    workjobs,
    onFilterApply})=>{
        const { palette } = useTheme()
        const [searchState, setSearchState] = useState({...defaultStage})
        
        
        const resetSearch = ()=>{
            setSearchState(defaultStage)
            notifyFiler(defaultStage);
        }

        const notifyFiler = (state) => {
            if(onFilterApply){

                //Filter non-empty object
                let o = Object.keys(state)
  .filter((k) => (state[k] != null && state[k]!== ''))
  .reduce((a, k) => ({ ...a, [k]: state[k] }), {});
                
                
                onFilterApply(o)
            }

        }

        const handleSearchChange = (event) => {
        
            setSearchState({
                ...searchState,
                [event.target.name]: event.target.value,
            })
        }
        const handleSerchSubmit = (event) => {
            notifyFiler(searchState);
        }

        const labelSx = {
            display: 'inline-block', 
            verticalAlign:'bottom', 
            width: '100px',
            color: palette.text.primary
        }

        return (<ValidatorForm
            onSubmit={handleSerchSubmit}
            onError={() => null}
            style={{marginBottom:'10px'}}
        ><H5>ตัวกรองข้อมูล</H5>
            <Grid container>
                
                <Grid item lg={4} md={4} sm={12} xs={12}>
                    <Box sx={{mt:1}}>
                    <InputLabel htmlFor="search" disableAnimation={true} sx={labelSx}>คำค้น</InputLabel>
                    <TextField 
                    sx={{minWidth:'250px'}}
                                type="text"
                                name="search"
                                id="search-text"
                                variant="standard"
                                onChange={handleSearchChange}
                                value={searchState.search}
                                label="เลขประจำตัว/ ชื่อ / นามสกุล"
                            />
                    
                    </Box>

                    <Box sx={{mt:1}}>
                    <InputLabel htmlFor="location" disableAnimation={true} sx={labelSx}>พื้นที่ปฏิบัติงาน</InputLabel>
                    <Select sx={{minWidth:'250px'}}
                                id="seach-location"
                                name="location"
                                onChange={handleSearchChange}
                                label="เลือกพื้นที่"
                                value={searchState.location}
                                variant="standard"
                            >
                                <MenuItem value="">
                                    <em>ไม่ระบุ</em>
                                </MenuItem>
                                {
                                        locations.map((row, index) => { return <MenuItem value={row.location_id}>{row.location_name}</MenuItem>})
                                    }
                            </Select>
                    
                    </Box>

                    <Box sx={{mt:1}}>
                        <InputLabel htmlFor="supervisor" disableAnimation={true} sx={labelSx}>ผู้ควบคุมงาน</InputLabel>
                        <Select sx={{minWidth:'250px'}}
                                    id="seach-foreman"
                                    name="supervisor"
                                    onChange={handleSearchChange}
                                    label="เลือผู้ควบคุมงาน"
                                    variant="standard"
                                    value={searchState.supervisor}
                                    
                                >
                                    <MenuItem value="">
                                        <em>ไม่ระบุ</em>
                                    </MenuItem>
                                    {
                                        foremen.map((row, index) => { return <MenuItem value={row.foreman_id}>{row.name} {row.lastname}</MenuItem>})
                                    }
                        </Select>
                    
                    </Box>
                    

                </Grid>
                <Grid item lg={4} md={4} sm={12} xs={12} sx={{mt:2}}>
                    <Box sx={{mt:1}}>
                        <InputLabel htmlFor="work-title" disableAnimation={true} sx={labelSx}>ตำแหน่งงาน</InputLabel>
                        <Select sx={{minWidth:'250px'}}
                                    id="seach-work"
                                    name="work"
                                    onChange={handleSearchChange}
                                    label="เลือกตำแน่งงาน"
                                    variant="standard"
                                    value={searchState.work}
                                >
                                    <MenuItem value="">
                                        <em>ไม่ระบุ</em>
                                    </MenuItem>
                                    {
                                        workjobs.map((row, index) => { return <MenuItem value={row.job_id}>{row.job_name}</MenuItem>})
                                    }
                                </Select>
                    
                    </Box>
                    <Box sx={{mt:1}}>
                        <InputLabel htmlFor="work-company" disableAnimation={true} sx={labelSx}>บริษัท</InputLabel>
                        <Select sx={{minWidth:'250px'}}
                                    id="seach-company"
                                    name="company"
                                    onChange={handleSearchChange}
                                    label="เลือกบริษัท"
                                    variant="standard"
                                    value={searchState.company}
                                >
                                    <MenuItem value="">
                                        <em>ไม่ระบุ</em>
                                    </MenuItem>
                                    {
                                        companies.map((row, index) => { return <MenuItem value={row.company_id}>{row.name}</MenuItem>})
                                    }
                                </Select>
                    
                    </Box>
                    <Box sx={{mt:1}}>
                        <InputLabel htmlFor="item_name" disableAnimation={true} sx={labelSx}>การตรวจ</InputLabel>
                        <Select sx={{minWidth:'250px'}}
                                    id="item_name"
                                    name="item_name"
                                    onChange={handleSearchChange}
                                    label="เลือกการตรวจ"
                                    variant="standard"
                                    value={searchState.item_name}
                                >
                                    <MenuItem value="">
                                        <em>ไม่ระบุ</em>
                                    </MenuItem>
                                    {
                                        tests.map((row, index) => { return <MenuItem value={row.value}>{row.name}</MenuItem>})
                                    }
                                </Select>
                    
                    </Box>
                </Grid>
                <Grid item lg={4} md={4} sm={12} xs={12}>
                
                <Box sx={{mt:1}}>
                        <Button  sx={{mt:1, minWidth:"120px", textAlign:"left"}} variant="contained" startIcon={<Icon>search</Icon>}
                                type="submit"
                                size="small"
                                aria-label="search"
                        >
                        ค้นหา
                        </Button>
                    </Box>
                    <Box>
                        <Button  sx={{mt:1, minWidth:"120px"}} variant="contained" startIcon={<Icon>rotate_left</Icon>}
                        onClick={resetSearch}
                        size="small"
                        aria-label="search"
                        
                        >
                        ล้างการค้นหา
                    </Button>
                    </Box>
                </Grid>
            </Grid>
            
        </ValidatorForm>)
    
}

export default SearchFilter